// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_hm","advertDetailContactItem__link":"c-m_hn","advertDetailContactItem__stub":"c-m_ho"};